import { getViewMemberId } from 'find-and-filter-data/view-members-schema/public';
import Raven from 'raven-js';
export function mergeAdded(addedMembers, viewMembers) {
  const indexedRecords = addedMembers.reduce((indexedMembers, currViewMember) => {
    try {
      //If the member being added already exists, don't add/update it.
      if (indexedMembers.get(getViewMemberId(currViewMember))) {
        return indexedMembers;
      }
      return indexedMembers.set(getViewMemberId(currViewMember), currViewMember);
    } catch (e) {
      Raven.captureException(e, {
        extra: {
          currViewMemberType: typeof currViewMember,
          indexedMembersType: typeof indexedMembers,
          viewMemberId: `${getViewMemberId(currViewMember)}`
        }
      });
      return indexedMembers;
    }
  }, viewMembers);
  return indexedRecords;
}
export function mergeUpserted(upsertedMembers, viewMembers) {
  const indexedRecords = upsertedMembers.reduce((indexedMembers, currViewMember) => {
    try {
      return indexedMembers.set(getViewMemberId(currViewMember), currViewMember);
    } catch (e) {
      Raven.captureException(e, {
        extra: {
          currViewMemberType: typeof currViewMember,
          indexedMembersType: typeof indexedMembers,
          viewMemberId: `${getViewMemberId(currViewMember)}`
        }
      });
      return indexedMembers;
    }
  }, viewMembers);
  return indexedRecords;
}
export function mergeUpdated(updatedViewMembers, viewMembers) {
  const indexedRecords = updatedViewMembers.reduce((indexedMembers, currViewMember) => {
    try {
      //If the member being updated doesn't already exist, don't add/update it.
      if (!indexedMembers.get(getViewMemberId(currViewMember))) {
        return indexedMembers;
      }
      return indexedMembers.set(getViewMemberId(currViewMember), currViewMember);
    } catch (e) {
      Raven.captureException(e, {
        extra: {
          currViewMemberType: typeof currViewMember,
          indexedMembersType: typeof indexedMembers,
          viewMemberId: `${getViewMemberId(currViewMember)}`
        }
      });
      return indexedMembers;
    }
  }, viewMembers);
  return indexedRecords;
}
export function mergeRemoved(removedMembers, viewMembers) {
  return removedMembers.reduce((members, removed) => {
    try {
      return members.delete(getViewMemberId(removed));
    } catch (e) {
      Raven.captureException(e, {
        extra: {
          currViewMemberType: typeof members.get(getViewMemberId(removed)),
          viewMemberId: getViewMemberId(removed)
        }
      });
      return members;
    }
  }, viewMembers);
}
export function mergeRemovedTickets(removedIds, viewMembers) {
  return removedIds.reduce((members, removedId) => {
    try {
      return members.delete(`${removedId}`);
    } catch (e) {
      Raven.captureException(e, {
        extra: {
          currViewMemberType: typeof members.get(`${removedId}`),
          viewMemberId: `${removedId}`
        }
      });
      return members;
    }
  }, viewMembers);
}

/**
 * @description This function will take a realtime ViewUpdate message and
 * apply all the changes to the given map of ViewMembers, returning a new map
 * with all those applied changes.
 *
 * @param viewMembers
 * @param viewMembersUpdated
 */
export function applyHelpDeskViewUpdateMessage(viewMembers, viewMembersUpdated) {
  const addedMembers = mergeAdded(viewMembersUpdated.added, viewMembers);
  const updatedMembers = mergeUpdated(viewMembersUpdated.updated, addedMembers);
  return updatedMembers;
}
export function applyHelpDeskBulkUpdateMessage(viewMembers, viewMembersUpdated) {
  const addedMembers = mergeAdded(viewMembersUpdated.added, viewMembers);
  const upsertedMembers = mergeUpserted(viewMembersUpdated.updated, addedMembers);
  if (viewMembersUpdated.removed) {
    const updatedMembers = mergeRemovedTickets(viewMembersUpdated.removed, upsertedMembers);
    return updatedMembers;
  }
  return upsertedMembers;
}